import React from "react"
import styled from "styled-components"
import { useBreakpoints } from "src/lib/hooks/use-breakpoints"
import { Text } from "components/text/Text"
import { colors } from "src/styles/colors"
import Button from "antd/es/button"
import { navigate } from "gatsby"

import Calendar from "assets/icons/schritt/calendar.svg"
import Student from "assets/icons/schritt/student.svg"
import Trophe from "assets/icons/schritt/trophe.svg"

const Wrapper = styled.div<any>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ minWideDesktop }) => (minWideDesktop ? "95px 0" : "60px 0")};
  flex-direction: ${({ minWideDesktop }) => (minWideDesktop ? "row" : "column")};
  & span {
    display: block;
  }
`
const SchrittText = styled.div<any>`
  display: flex;
  justify-content: center;
  flex-direction: column;
`
const Side = styled.div<any>`
  width: ${({ minWideDesktop }) => (minWideDesktop ? "calc(50% - 12px)" : "100%")};
  text-align: ${({ minWideDesktop }) => (minWideDesktop ? "left" : "center")};
`

const Schritt = styled.div<any>`
  display: flex;
  margin-bottom: 20px;
  background-color: ${colors.white};
  border-radius: 10px;
  padding: 16px 20px 21px 16px;
  text-align: left;
  width: ${({ minWideDesktop }) => (minWideDesktop ? "360px" : "100%")};
  margin-left: calc(${({ minWideDesktop, idx }) => (minWideDesktop ? idx * 84 : 0)}px);
  & img {
    height: 52px;
    width: 54px;
  }
`

const Schritts = [
  {
    icon: Student,
    message: "Vergleichen (online oder in der Nähe)",
  },
  {
    icon: Calendar,
    message: "Gratis Vermittlung",
  },
  {
    icon: Trophe,
    message: "Privater Unterricht",
  },
]

type Props = {
  firstText: string
  secondTest: string
  firstButtonText: string
  firstButtonLink: string
  secondButtonText: string
  secondButtonLink: string
}

export const CTASection: React.FC<Props> = ({
  firstText,
  secondTest,
  firstButtonText,
  firstButtonLink,
  secondButtonText,
  secondButtonLink,
}) => {
  const { minWideDesktop } = useBreakpoints()

  const onClickCompare = () => {
    navigate(firstButtonLink)
  }
  const onClickBecome = () => {
    navigate(secondButtonLink)
  }

  return (
    <Wrapper minWideDesktop={minWideDesktop}>
      <Side minWideDesktop={minWideDesktop} style={{ marginBottom: minWideDesktop ? 0 : 36 }}>
        <Text
          color={colors.white}
          size={30}
          fontWeight={600}
          style={{ marginBottom: minWideDesktop ? 24 : 13 }}
        >
          {firstText}
        </Text>
        <Text
          color={colors.white}
          size={18}
          style={{ marginBottom: minWideDesktop ? 36 : 16 }}
        >
          {secondTest}
        </Text>
        <Button
          type="primary"
          size="large"
          style={{
            width: minWideDesktop ? 300 : "calc(100% - 32px)",
            marginBottom: 22,
          }}
          onClick={onClickCompare}
        >
          {firstButtonText}
        </Button>
        <Button
          type="link"
          size="small"
          style={{
            textDecoration: "underline",
            marginRight: minWideDesktop ? "100%" : 0,
            color: colors.white,
            padding: 0,
          }}
          onClick={onClickBecome}
        >
          {secondButtonText}
        </Button>
      </Side>
      <Side minWideDesktop={minWideDesktop}>
        {Schritts.map(({ icon, message }, idx) => {
          return (
            <Schritt minWideDesktop={minWideDesktop} idx={idx} key={idx}>
              <img
                src={icon}
                style={{ marginRight: 10 }}
                alt={message}
                loading="lazy"
              />
              <SchrittText>
                <Text
                  color={colors.gray11}
                  size={14}
                  style={{ marginBottom: 2 }}
                >
                  Schritt {idx + 1}
                </Text>
                <Text color={colors.black} size={14} fontWeight={600}>
                  {message}
                </Text>
              </SchrittText>
            </Schritt>
          )
        })}
      </Side>
    </Wrapper>
  )
}
